export function downloadFromMemory(filename: string, data: string): void {
    const element = document.createElement("a")
    element.href = "data:text/plain;charset=utf-8," + encodeURIComponent(data)
    element.download = filename
    element.style.display = "none"
    document.body.appendChild(element)
    element.click()
    document.body.removeChild(element)
}
